import { request } from '@@/plugin-request/request';
import { RequestData } from '@ant-design/pro-table';

export interface CardPendingEmbossedListItem {
  cardId: string;
  cardNumber: string;
  cardProduct: string;
  cardEmbossedName: string;
  accountId: string;
  relationshipManager: string;
  cardIssuedAt: Date;
  userId: string;
  fulfillmentNote: string;
  cardProductId: string;
  clientName: string;
  cardholderName: string;
  vendorId?: number;
  disputeRaised: boolean;
  lastDisputeTime: string;
}

export async function getCardPendingEmbossedList(params: any): Promise<RequestData<CardPendingEmbossedListItem>> {
  return await request<RequestData<CardPendingEmbossedListItem>>('/cms/cards/pending-embossed', { params });
}

export async function getCardPendingEmbossedCounts(): Promise<Record<string, number>> {
  return await request<Record<string, number>>('/cms/cards/pending-embossed/counts');
}
